/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { EmployeesData, EmployeesService }  from './Employees.service';


@Component({
  selector: 'EmployeesSearch',
  template: require('./EmployeesSearch.component.html'),
  providers: [EmployeesService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeesSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objEmployees: EmployeesData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private EmployeesService: EmployeesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objEmployees = new EmployeesData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objEmployees = new EmployeesData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objEmployees.EmployeeID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objEmployees.EmployeeID;
			else
				this.filterExpression = "EmployeeID = " + this.objEmployees.EmployeeID;
		}
		if (this.objEmployees.LastName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND LastName like '%" + this.objEmployees.LastName + "%'";
			else
				this.filterExpression = "LastName like '%" + this.objEmployees.LastName + "%'";
		}
		if (this.objEmployees.FirstName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND FirstName like '%" + this.objEmployees.FirstName + "%'";
			else
				this.filterExpression = "FirstName like '%" + this.objEmployees.FirstName + "%'";
		}
		if (this.objEmployees.Title)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Title like '%" + this.objEmployees.Title + "%'";
			else
				this.filterExpression = "Title like '%" + this.objEmployees.Title + "%'";
		}
		if (this.objEmployees.TitleOfCourtesy)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND TitleOfCourtesy like '%" + this.objEmployees.TitleOfCourtesy + "%'";
			else
				this.filterExpression = "TitleOfCourtesy like '%" + this.objEmployees.TitleOfCourtesy + "%'";
		}
		if (this.objEmployees.Address)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Address like '%" + this.objEmployees.Address + "%'";
			else
				this.filterExpression = "Address like '%" + this.objEmployees.Address + "%'";
		}
		if (this.objEmployees.City)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND City like '%" + this.objEmployees.City + "%'";
			else
				this.filterExpression = "City like '%" + this.objEmployees.City + "%'";
		}
		if (this.objEmployees.Region)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Region like '%" + this.objEmployees.Region + "%'";
			else
				this.filterExpression = "Region like '%" + this.objEmployees.Region + "%'";
		}
		if (this.objEmployees.PostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objEmployees.PostalCode + "%'";
			else
				this.filterExpression = "PostalCode like '%" + this.objEmployees.PostalCode + "%'";
		}
		if (this.objEmployees.Country)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Country like '%" + this.objEmployees.Country + "%'";
			else
				this.filterExpression = "Country like '%" + this.objEmployees.Country + "%'";
		}
		if (this.objEmployees.HomePhone)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND HomePhone like '%" + this.objEmployees.HomePhone + "%'";
			else
				this.filterExpression = "HomePhone like '%" + this.objEmployees.HomePhone + "%'";
		}
		if (this.objEmployees.Extension)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Extension like '%" + this.objEmployees.Extension + "%'";
			else
				this.filterExpression = "Extension like '%" + this.objEmployees.Extension + "%'";
		}
		if (this.objEmployees.Notes)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Notes like '%" + this.objEmployees.Notes + "%'";
			else
				this.filterExpression = "Notes like '%" + this.objEmployees.Notes + "%'";
		}
		if (this.objEmployees.ReportsTo)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ReportsTo = " + this.objEmployees.ReportsTo;
			else
				this.filterExpression = "ReportsTo = " + this.objEmployees.ReportsTo;
		}
		if (this.objEmployees.PhotoPath)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND PhotoPath like '%" + this.objEmployees.PhotoPath + "%'";
			else
				this.filterExpression = "PhotoPath like '%" + this.objEmployees.PhotoPath + "%'";
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}


	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }

	getLookups() {

        this.getEmployees();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/EmployeesSearch.component.ts